import { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext({ theme: "system", resolved: "light", setTheme: () => {}, toggle: () => {} });

const getSystem = () =>
  typeof window !== "undefined" && window.matchMedia?.("(prefers-color-scheme: dark)").matches ? "dark" : "light";

const initial = () => {
  try {
    const u = new URLSearchParams(window.location.search).get("theme");
    if (u === "dark" || u === "light" || u === "system") return u;
  } catch (e) {}
  return localStorage.getItem("wedding_theme_preference") || "system";
};

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(initial);
  const [resolved, setResolved] = useState(() => (initial() === "system" ? getSystem() : initial()));

  useEffect(() => {
    const apply = () => {
      const r = theme === "system" ? getSystem() : theme;
      setResolved(r);
      document.documentElement.classList.toggle("dark", r === "dark");
    };
    apply();
    localStorage.setItem("wedding_theme_preference", theme);
    if (theme === "system") {
      const mq = window.matchMedia("(prefers-color-scheme: dark)");
      mq.addEventListener("change", apply);
      return () => mq.removeEventListener("change", apply);
    }
  }, [theme]);

  const toggle = () => setTheme((t) => (t === "light" ? "dark" : t === "dark" ? "system" : "light"));

  return <ThemeContext.Provider value={{ theme, resolved, setTheme, toggle }}>{children}</ThemeContext.Provider>;
};

export const useTheme = () => useContext(ThemeContext);
